import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faCompass, faRotate } from "@fortawesome/free-solid-svg-icons";
import "./../styles/SideBar.style.css";
import resourcesService from "../services/Resources";
import resourceTypes from "../models/ResourcesTypes";
import statusTypes from "../models/StatusType";
import keywords from "../models/Keywords";

interface SideBarProps {
  setFilter: (filter: string) => void;
  setResourceType: (type: string) => void;
  setStatusType: (status: string) => void;
  reload: boolean;
  setAnyFilter: (value: boolean) => void;
  setZeroRun: (value: boolean) => void;
  currentView: "monitor" | "equipment" | "reprocess";
  setCurrentView: (view: "monitor" | "equipment" | "reprocess") => void;
}

const SideBar = (props: SideBarProps) => {
  const {
    setFilter,
    setResourceType,
    setStatusType,
    reload,
    setAnyFilter,
    setZeroRun,
    currentView,
    setCurrentView,
  } = props;

  const [pipelines, setPipelines] = useState<string[]>([]);

  useEffect(() => {
    resourcesService.getPipelines().then((res) => setPipelines(res.pipelines));
  }, [reload]);

  function resetAll() {
    setFilter("");
    setResourceType("");
    setStatusType("");
    setAnyFilter(false);
    setZeroRun(false);
  }

  return (
    <div className="sidebar-container">
      <div className="selector">
        <h3>KPI Radar</h3>
        <span
          className="nav-link"
          onClick={() => setCurrentView("monitor")}
          style={{ fontWeight: currentView === "monitor" ? "bold" : "normal" }}
        >
          <FontAwesomeIcon icon={faChartLine} className="nav-icon" />
          Monitor
        </span>
        <span
          className="nav-link"
          onClick={() => setCurrentView("equipment")}
          style={{ fontWeight: currentView === "equipment" ? "bold" : "normal" }}
        >
          <FontAwesomeIcon icon={faCompass} className="nav-icon" />
          Equipment Explorer
        </span>
        <span
          className="nav-link"
          onClick={() => setCurrentView("reprocess")}
          style={{ fontWeight: currentView === "reprocess" ? "bold" : "normal" }}
        >
          <FontAwesomeIcon icon={faRotate} className="nav-icon" />
          Reprocess
        </span>
      </div>
      {currentView === "monitor" && (
        <React.Fragment>
          <div className="selector">
            <h3>Filters</h3>
            <span onClick={resetAll}>reset all filters</span>
            <span onClick={() => setAnyFilter(true)}>any %</span>
            <span onClick={() => setZeroRun(true)}>0 run</span>
          </div>
          <div className="grid">
            <div className="selector">
              <h3>Status</h3>
              {statusTypes &&
                statusTypes.map((stype, index: number) => (
                  <div className="status-container" key={index}>
                    <div
                      className="status"
                      style={{ background: stype.color }}
                    ></div>
                    <span
                      onClick={() =>
                        setStatusType(stype.name === "all" ? "" : stype.name)
                      }
                    >
                      {stype.name}
                    </span>
                  </div>
                ))}
            </div>
            <div className="selector">
              <h3>Keywords</h3>
              <span onClick={() => setFilter("")}>all</span>
              {keywords.map((keyword: string, index: number) => (
                <span key={index} onClick={() => setFilter(keyword)}>
                  {keyword}
                </span>
              ))}
            </div>
            <div className="selector">
              <h3>Types</h3>
              {resourceTypes.map((rtype, index: number) => (
                <span
                  className="label"
                  key={index}
                  onClick={() =>
                    setResourceType(rtype.name === "all" ? "" : rtype.name)
                  }
                  style={{ background: rtype.color }}
                >
                  {rtype.name}
                </span>
              ))}
            </div>

            <div className="selector">
              <h3>Pipelines</h3>
              <span onClick={() => setFilter("")}>all</span>
              {pipelines &&
                pipelines.map((pipeline: string, index: number) => (
                  <span key={index} onClick={() => setFilter(pipeline)}>
                    {pipeline}
                  </span>
                ))}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default SideBar;